module.exports = __webpack_public_path__ + "img/2.2cc64084.jpg";